$(document).ready(function () {
    // Initialize Slick slider
    setInterval(() => {
      if($('.main-slider.slick-initialized').length){
      }else{
        $(".main-slider").slick({
          dots: false,
          arrows: true,
          prevArrow: $(".left-arrow"),
          nextArrow: $(".right-arrow"),
          
          slidesToScroll:1, // Number of slides to scroll
          slidesToShow: 1, // Number of slides to show at a time
        });
      }
    }, 100);
  });
    